import { Modal as ModalComponent } from 'react-bootstrap';
import ModalDefaultProps from 'react-bootstrap/Modal';
import { ModalHeader, ModalHeaderProps } from './ModalHeader';

type ModalProps = typeof ModalDefaultProps & {
	Header: ModalHeaderProps;
};

export default Object.assign(ModalComponent as ModalProps, {
	Header: ModalHeader,
});
